import type { PanelSalesInquiryListQuery } from '@icebreaker/shared';
import type { SalesFilters } from '../store/sales-inquiries.slice';

/** Listenin sayfa boyu. Sayfalama sunucuda; sayı sabit, toplam yanıtta. */
export const SALES_PAGE_SIZE = 20;

/** Ekran süzgeçleri → sunucu sorgusu. `all` ve boş arama sorguya GİRMEZ. */
export function toSalesQuery(filters: SalesFilters): PanelSalesInquiryListQuery {
  const q = filters.q.trim();
  return {
    ...(filters.status === 'all' ? {} : { status: filters.status }),
    ...(q ? { q } : {}),
    page: filters.page,
    pageSize: SALES_PAGE_SIZE,
  };
}

/** Kurum açma seçicisi: kuruma bağlanmamış, anonimleşmemiş, spam olmayan adaylar. */
export function isLinkableLead(row: {
  readonly anonymized: boolean;
  readonly organization: unknown;
  readonly status: string;
}): boolean {
  return !row.anonymized && row.organization === null && row.status !== 'spam';
}
